import { schema } from "normalizr";

const uploadedFile = new schema.Entity(`uploaded_files`, {}, { idAttribute: `code` });
const arrayOfUploadedFiles = [uploadedFile];

export { uploadedFile, arrayOfUploadedFiles };
